import { ref, type InjectionKey } from "vue";
import type { OrderContextDto, OrderDto, ProductVariantDto} from "./gfo_api/order_api";
import type { AppConfig } from "./app_config_provider";

export function CurrentOrderProvider(config: AppConfig) {
  const currentOrder = ref<OrderDto|null>(null);
  const currentOrderContext = ref<OrderContextDto|null>(null);
  // die zuletzt abgeschlossene Bestellung, z.B. für die Bestellbestätigungsseite
  const previousOrder = ref<OrderDto|null>(null);
  const previousOrderContext = ref<OrderContextDto|null>(null);
  const availableVariants = ref<ProductVariantDto[]>([]);
  const set = (order: OrderDto|null) => {
    previousOrder.value = null == order ? currentOrder.value : null;
    currentOrder.value = order;
    if (null == order){
        document.cookie = `${config.cookie_name}=; Max-Age=0; path=/;`;
    } else {
      document.cookie = `${config.cookie_name}=${order.order_reference}; path=/;`;
    }
  }
  const setPreviousOrder = (order: OrderDto|null) => {
    previousOrder.value = order;
  }

  const setVariants = (variants: ProductVariantDto[]) => {
    availableVariants.value = variants;
  }
  const setOrderContext = (context: OrderContextDto|null) => {
    currentOrderContext.value = context;
  }
  const setPreviousOrderContext = (context: OrderContextDto|null) => {
    previousOrderContext.value = context;
  }
  return { currentOrder, currentOrderContext, previousOrder, previousOrderContext, availableVariants, set, setVariants, setPreviousOrder, setOrderContext, setPreviousOrderContext }
}

// gibt bei der injection automatisch den richtigen Typ
export const currentOrderProviderKey: InjectionKey<ReturnType<typeof CurrentOrderProvider>> = Symbol("current-order-provider");